module.exports = __webpack_public_path__ + "img/deuteranopia-palette-thumb.10587231.png";